import { render, staticRenderFns } from "./TalentPortrait.vue?vue&type=template&id=7fa4f158&scoped=true&"
import script from "./TalentPortrait.vue?vue&type=script&lang=js&"
export * from "./TalentPortrait.vue?vue&type=script&lang=js&"
import style0 from "./TalentPortrait.vue?vue&type=style&index=0&id=7fa4f158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4f158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa4f158')) {
      api.createRecord('7fa4f158', component.options)
    } else {
      api.reload('7fa4f158', component.options)
    }
    module.hot.accept("./TalentPortrait.vue?vue&type=template&id=7fa4f158&scoped=true&", function () {
      api.rerender('7fa4f158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/TalentPortrait.vue"
export default component.exports